import SearchResult from "@/views/chat/SearchResult";

export default {
  name: "SelectAddressModal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    hide: {
      type: Function,
      default: () => {
      }
    },
    onSelect: {
      type: Function,
      default: () => {
      }
    },
    chat_id: {
      type: String,
      default: ""
    },
  },
  components: {
    SearchResult
  },
  computed: {
    searchResults() {
      if (this.searchText) {
        return this.results.filter(
          x => x.type === "address" ?
            x.address.description.toLowerCase().includes(this.searchText) :
            x.event.address.toLowerCase().includes(this.searchText)
        );
      } else {
        return this.results;
      }
    }
  },
  filters: {
    showAddress(item) {
      if (item.type === "address") {
        return item.address.description;
      } else if (item.type === "event") {
        return item.event.address;
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.results = [];
        this.searchText = "";
        this.search();
      }
      this.showModal = val;
    },
    searchText(val) {
      if (val) {
        this.search();
      }
    }
  },
  created() {
    this.showModal = this.show;
    this.search();
  },
  data() {
    return {
      results: [],
      showModal: false,
      showResultSearch: false,
      searchTimeOut: null,
      searchText: ""
    }
  },
  methods: {
    search() {
      const self = this;
      this.$store.dispatch("Chat/search_address", {
        search: this.searchText,
        chat_id: this.chat_id
      })
        .then(docs => {
          self.results = [];
          for (const doc of docs) {
            self.results.push({...doc.data(), message_id: doc.id});
          }
        })
        .catch(error => console.error(error));
    },
    confirm(item) {
      this.onSelect(item);
      this.hideModal();
    },
    hideModal() {
      this.showModal = false;
      this.hide();
    }
  }
}